import {createAction} from "redux-act";
import {IDictionary, IError} from "modules/types";

export const fetchChecksums = createAction();
export const fetchChecksumsSuccess = createAction<IDictionary<string>>();
export const fetchChecksumsFailed = createAction<IError>();
